// @flow
import styled from 'styled-components'
import theme from '../../../../styles/theme'

export const IconWrapper = styled.svg`
  fill: ${props => props.fill || theme.bodyFontColor};
  width: 1em;
  height: 1em;
  display: block;
  font-size: 24px;
  user-select: none;
  flex-shrink: 0;
  transform: rotate(${props => (props.active ? 180 : 0)}deg);
  transition: transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`
